export const ANALOG_STATIC_IMPORT_YAML = `project:
  name: recipe-analog
  tags:
    - zerops-recipe

services:
  - hostname: app
    type: static
    enableSubdomainAccess: true
    buildFromGit: https://github.com/zeropsio/recipe-analog-static`;
